import { render, staticRenderFns } from "./ContactMoney.vue?vue&type=template&id=61e2eab6&scoped=true"
import script from "./ContactMoney.vue?vue&type=script&lang=js"
export * from "./ContactMoney.vue?vue&type=script&lang=js"
import style0 from "./ContactMoney.vue?vue&type=style&index=0&id=61e2eab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e2eab6",
  null
  
)

export default component.exports